import { Action } from '@ngrx/store';
import { HttpErrorResponse } from '@angular/common/http';
import { ShippingChargesCriteria, ShippingCharge } from '../../models';

export enum DistributionActionTypes {
  LoadShippingCharges = '[Distribution] Load Shipping Charges',
  LoadShippingChargesSuccess = '[Distribution] Load Shipping Charges Success',
  LoadShippingChargesFailure = '[Distribution] Load Shipping Charges Failure',
  UpdateShippingCharges = '[Distribution] Update Shipping Charges',
  UpdateShippingChargesSuccess = '[Distribution] Update Shipping Charges Success',
  UpdateShippingChargesFailure = '[Distribution] Update Shipping Charges Failure',
}

export class LoadShippingCharges implements Action {
  readonly type = DistributionActionTypes.LoadShippingCharges;
  constructor(public payload: ShippingChargesCriteria) { }
}

export class LoadShippingChargesSuccess implements Action {
  readonly type = DistributionActionTypes.LoadShippingChargesSuccess;
  constructor(public payload: ShippingCharge[]) { }
}

export class LoadShippingChargesFailure implements Action {
  readonly type = DistributionActionTypes.LoadShippingChargesFailure;
  constructor(public payload: any) { }
}
export class UpdateShippingCharges implements Action {
  readonly type = DistributionActionTypes.UpdateShippingCharges;
  constructor(public payload: { changed: ShippingCharge[] }) { }
}

export class UpdateShippingChargesSuccess implements Action {
  readonly type = DistributionActionTypes.UpdateShippingChargesSuccess;
  constructor(public payload: { changed: ShippingCharge[] }) { }
}

export class UpdateShippingChargesFailure implements Action {
  readonly type = DistributionActionTypes.UpdateShippingChargesFailure;
  constructor(public payload: any) { }
}

export type DistributionActions =
  LoadShippingCharges
  | LoadShippingChargesFailure
  | LoadShippingChargesSuccess
  | UpdateShippingCharges
  | UpdateShippingChargesSuccess
  | UpdateShippingChargesFailure
